var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYorBackground1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 192,
    viewBox: "0 0 238 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.34 124.323C224.206 89.9611 238.98 46.4988 237.95 1.91914C236.919 -42.6605 220.152 -85.3642 190.729 -118.348C161.306 -151.332 121.202 -172.382 77.7833 -177.631C34.3649 -182.88 -9.45281 -171.977 -45.6216 -146.922C-81.7904 -121.868 -107.882 -84.346 -119.103 -41.2476C-130.325 1.85077 -125.923 47.6314 -106.707 87.6857C-87.4901 127.74 -54.7492 159.378 -14.4974 176.79C25.7544 194.201 70.8142 196.216 112.406 182.465L94.6516 126.608C66.2465 136 35.4727 134.623 7.98254 122.732C-19.5076 110.841 -41.8682 89.2335 -54.9922 61.8783C-68.1161 34.523 -71.1223 3.25694 -63.4585 -26.1773C-55.7947 -55.6115 -37.9755 -81.2375 -13.2739 -98.3483C11.4277 -115.459 41.3532 -122.906 71.006 -119.321C100.659 -115.736 128.048 -101.36 148.143 -78.8335C168.237 -56.3069 179.688 -27.1422 180.392 3.30364C181.096 33.7495 171.006 63.4323 151.975 86.9001L196.34 124.323Z",
    fill: "url(#paint0_linear_312_4918)",
    fillOpacity: 0.12
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_312_4918",
    x1: -93.8318,
    y1: -51.4073,
    x2: 145.311,
    y2: 190.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843672,
    stopColor: "#D8E6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D8E4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYorBackground1);
export default __webpack_public_path__ + "static/media/yorBackground1.05dd7071b832000d746d1236827739ad.svg";
export { ForwardRef as ReactComponent };